import * as Lambda from './LambdaApi';

const getFamilyList = async (residentId) => {
    const apiPath = `/residents/${residentId}/relatives`;
    const relativeData = await Lambda.Get(apiPath, {}, 'lambda');
    return relativeData;
};

const getRelativeDetail = async (residentId, relativeId) => {
    const apiPath = `/residents/${residentId}/relatives/${relativeId}`;
    const relativeData = await Lambda.Get(apiPath, {}, 'lambda');
    return relativeData;
};

const updateRelative = async (residentId, relativeId, payload) => {
    const apiPath = `/residents/${residentId}/relatives/${relativeId}`;
    const relativeData = await Lambda.Put(apiPath, { ...payload }, 'lambda');
    return relativeData;
};

const updateRelativeImage = async (residentId, relativeId, imageURL) => {
    const apiPath = `/residents/${residentId}/relatives/${relativeId}`;
    const relativeData = await Lambda.Put(apiPath, { Image: imageURL }, 'lambda');
    return relativeData;
};

const updateCanListenToStories = async (residentId, relativeId, value) => {
    const apiPath = `/residents/${residentId}/relatives/${relativeId}`;

    const relativeData = await Lambda.Put(
        apiPath,
        {
            canListenToStories: value,
        },
        'lambda',
    );

    return relativeData;
};
const updateCanRecieveRequests = async (residentId, relativeId, value) => {
    const apiPath = `/residents/${residentId}/relatives/${relativeId}`;

    const relativeData = await Lambda.Put(
        apiPath,
        {
            canRecieveRequests: value,
        },
        'lambda',
    );

    return relativeData;
};
const updateCanSeeFeed = async (residentId, relativeId, value) => {
    const apiPath = `/residents/${residentId}/relatives/${relativeId}`;

    const relativeData = await Lambda.Put(
        apiPath,
        {
            canSeeFeed: value,
        },
        'lambda',
    );

    return relativeData;
};
const updateManager = async (residentId, relativeId, value) => {
    const apiPath = `/residents/${residentId}/relatives/${relativeId}`;

    const relativeData = await Lambda.Put(
        apiPath,
        {
            Manager: value, 
        },
        'lambda',
    );
    
    return relativeData;
};
export {
    getFamilyList,
    getRelativeDetail,
    updateRelative,
    updateRelativeImage,
    updateCanListenToStories,
    updateCanRecieveRequests,
    updateCanSeeFeed,
    updateManager,
};
